/** @jsx h */
import { h, Component } from 'preact'
import transitionIn from '../transition-in'
import IS_IE from '../../utils/is-ie'

const NUMBER_OF_PANELS = 10
const ANGLE_PER_PANEL = 36

const getIsNumber = num => /\d/.test(num)

class Dial extends Component {
  constructor (props) {
    super(props)
    this.onRef = this.onRef.bind(this)
    this.state = {
      value: 0,
      widths: {}
    }
  }

  componentDidMount () {
    if (this.el) {
      const widths = {}
      let height = 0
      Array.prototype.slice
        .call(this.el.querySelectorAll('figure'))
        .forEach((child, index) => {
          if (index === 0) {
            height = child.clientHeight
          }
          widths[index] = child.clientWidth
        })
      setTimeout(() => this.setState({ widths, height }), 0)
    }
  }

  onRef (el) {
    if (el) {
      this.el = el
    }
  }

  render ({
    number,
    char,
    height,
    numberIndex,
    firstRender,
    fontSize,
    numberSpacing
  }) {
    const { widths } = this.state
    const children = []
    let containerTransform
    let relevantNumber = 0

    if (getIsNumber(char) && !IS_IE) {
      const numberAsString = number + ''
      const totalNumberOfNumbers = numberAsString.length
      const positionFromRight = totalNumberOfNumbers - numberIndex
      relevantNumber = firstRender ? 0 : Number(numberAsString[numberIndex])

      const position =
        positionFromRight - 1 ? Math.pow(10, positionFromRight - 1) : 1

      let extraRevs = Math.floor(
        (number - relevantNumber * position) / (position * 10)
      )

      // avoids issues with alignment in firefox/edge when
      // rotating millions of degrees
      if (extraRevs > 1000) {
        extraRevs = extraRevs % 1000
      }

      const angle = relevantNumber * ANGLE_PER_PANEL + extraRevs * 360
      const tz = Math.round(height / 2 / Math.tan(Math.PI / NUMBER_OF_PANELS))
      containerTransform = `translateZ(-${tz}px) rotateX(-${angle}deg)`

      let count = 0

      for (; count < NUMBER_OF_PANELS; count++) {
        let transform = `rotateX(${count *
          ANGLE_PER_PANEL}deg) translateZ(${tz}px)`
        children.push(
          <figure
            style={{
              display: 'block',
              position: 'absolute',
              height: '100%',
              margin: 0,
              paddingRight: `${numberSpacing}px`,
              textAlign: 'center',
              transform,
              backfaceVisibility: 'hidden',
              webkitBackfaceVisibility: 'hidden'
            }}
          >
            {count}
          </figure>
        )
      }
    } else {
      children.push(
        <figure
          style={{
            display: 'block',
            position: 'absolute',
            height: '100%',
            margin: 0,
            paddingRight: `${numberSpacing}px`,
            textAlign: 'center',
            transform: 'none'
          }}
        >
          {char}
        </figure>
      )
    }

    const adjustedWidth = widths[relevantNumber]

    return (
      <section
        style={{
          position: 'relative',
          opacity: firstRender ? 0 : 'inherit',
          height: height + 'px',
          width: adjustedWidth + 'px',
          fontSize: fontSize + 'px',
          perspective: '1000px',
          transition: 'opacity 500ms'
        }}
      >
        <div
          ref={this.onRef}
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            transform: containerTransform || 'none',
            transformStyle: 'preserve-3d',
            webkitTransformStyle: 'preserve-3d',
            transition: 'transform 1s'
          }}
        >
          {children}
        </div>
      </section>
    )
  }
}

export default transitionIn(Dial)
